import { selectShowKbSearchOnInboxEditor } from 'ducks/currentUser/selectors/preferences/selectShowKbSearchOnInboxEditor'
import { doUpdateUserPreferences } from 'ducks/currentUser/operations'
import { selectHasKnowledgebases } from 'ducks/ticketing/selectors/kbSearch'

export function doToggleShowKbSearchOnInboxEditor() {
  return (dispatch, getState) => {
    const state = getState()
    const showKbSearchOnInboxEditor = selectShowKbSearchOnInboxEditor(state)
    const hasKnowledgebases = selectHasKnowledgebases(state)
    if (hasKnowledgebases) {
      return doUpdateUserPreferences({
        show_kb_search_on_inbox_editor: !showKbSearchOnInboxEditor,
      })(dispatch, getState)
    }
    return Promise.resolve(null)
  }
}
